/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// German
export default {
    'fabric.atlassianSwitcher.switchTo': 'Wechseln zu',
    'fabric.atlassianSwitcher.switchToTooltip': 'Wechseln zu…',
    'fabric.atlassianSwitcher.recent': 'Letzte',
    'fabric.atlassianSwitcher.more': 'Mehr',
    'fabric.atlassianSwitcher.try': 'Ausprobieren',
    'fabric.atlassianSwitcher.manageList': 'Liste verwalten',
    'fabric.atlassianSwitcher.jiraProject': 'Jira-Projekt',
    'fabric.atlassianSwitcher.confluenceSpace': 'Confluence-Bereich',
    'fabric.atlassianSwitcher.people': 'Personen',
    'fabric.atlassianSwitcher.administration': 'Administration',
    'fabric.atlassianSwitcher.discoverMore': 'Mehr entdecken',
    'fabric.atlassianSwitcher.errorHeading': 'Irgendetwas ist schiefgelaufen',
    'fabric.atlassianSwitcher.errorText': 'Wir verfolgen diese Fehler, aber Sie können uns gerne kontaktieren, wenn das Problem nach dem Aktualisieren weiterhin besteht.',
    'fabric.atlassianSwitcher.errorImageAltText': 'Ein kaputter Roboter und viele Menschen, die ihn reparieren.',
    'fabric.atlassianSwitcher.expand': 'Erweiterte Erfahrung',
};
//# sourceMappingURL=de.js.map